import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket, faUser, faCalendar, faUsers, faInfoCircle, faMapMarkerAlt, faChair, faChevronLeft, faChevronRight, faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { createElement } from 'react';
import { renderToString } from 'react-dom/server';
import { getMyBookings } from '../../services/apiService';
import defaultEventImage from '../../assets/images/events/event-1.png';
import AuthCheck from '../../components/authCheck/AuthCheck';
import mcubeBanner1 from '../../assets/images/events/muthukad-event-banner-3.jpg';
import mcubeImage from '../../assets/images/events/mcube-ticket-2.jpg';
import fiestaBanner1 from '../../assets/images/events/Kairali-uk-poster-new.png';
import pranayanila from '../../assets/images/PRANAYANILA 3.png';
import Pranayanilaticket from '../../assets/images/PRANAYANILA-ticket-img.jpg'
import fiestaImage from '../../assets/images/events/Kairali-uk-tic.png';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

const MyBookingsPage = () => {
  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showTaxes, setShowTaxes] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);
  const [currentQRIndex, setCurrentQRIndex] = useState(0);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const ticketRef = useRef(null);

  // Helper function to get event images based on event title
  const getEventImages = (eventTitle) => {
    const title = eventTitle?.toLowerCase() || '';
    if (title.includes('mcube') || title.includes('magic') || title.includes('melody') || title.includes('mission')) {
      return {
        banner: mcubeBanner1,
        ticket: mcubeImage
      };
    }
       else if (title.includes('pranayanila') || title.includes('pranayanila 2.0')) {
      return {
        banner: pranayanila,
        ticket: Pranayanilaticket
      };
    
    }
     else if (title.includes('fiesta') || title.includes('xmas') || title.includes('new year') || title.includes('celebration')) {
      return {
        banner: fiestaBanner1,
        ticket: fiestaImage
      };
    }
    // Default fallback
    return {
      banner: defaultEventImage,
      ticket: defaultEventImage
    };
  };

  useEffect(() => {
    
    // Listen for auth error events
    const handleAuthError = () => {
      // Show login modal - use setTimeout to ensure DOM is ready
      setTimeout(() => {
        const modalElement = document.getElementById('authModal');
        if (modalElement && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
          try {
            // Check if modal instance already exists
            let modal = bootstrap.Modal.getInstance(modalElement);
            if (!modal) {
              // Create new modal instance
              modal = new bootstrap.Modal(modalElement);
            }
            modal.show();
          } catch (error) {
            console.error('Error showing modal:', error);
          }
        }
      }, 100);
      setError(null); // Clear any existing error
    };

    window.addEventListener('authError', handleAuthError);

    const fetchBookings = async () => {
      try {
        setLoading(true);
        const response = await getMyBookings(currentPage, "", limit);
        // Transform the API data to match the component's expected format
        const transformedBookings = response.data.map(booking => {
          // Seats are already an array of objects in the new API response
          const seatsData = booking.seats || [];

          // Extract section and tickets information from seats

          let section = 'General Admission';

if (seatsData.length > 0) {
   console.log('SEATS DATA:', seatsData);
 console.log('BOOKING:', booking.event.title);
console.log('SEATS RAW:', booking.seats);
// const response = await getMyBookings(currentPage, "", limit);
console.log("RAW API RESPONSE:", response);
console.log("BOOKINGS ARRAY:", response.data);

  const seat = seatsData[0];

  const isRoundTable =
    !seat.rowNumber &&
    !seat.seatNumber; // 🔥 Feast / round table detection

  if (isRoundTable) {
    // FEAST / ROUND TABLE
    const counts = seatsData.reduce((acc, s) => {
      const type = s.ticketType || 'adult';
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    const summary = Object.entries(counts)
      .map(
   

        ([type, count]) =>
          `${count} ${type.charAt(0).toUpperCase() + type.slice(1)}${count > 1 ? 's' : ''}`
      )
      .join(', ');

    section = `${seat.section} – ${seatsData.length} Seat${seatsData.length > 1 ? 's' : ''} (${summary})`;
  } else {
    // NORMAL SEATING (MCube)
    
    const ticketType = seat.ticketType
      ? seat.ticketType.charAt(0).toUpperCase() + seat.ticketType.slice(1)
      : 'Adult';

    section = `${seat.section} Row ${seat.rowNumber} – Seat ${seat.seatNumber} (${ticketType})`;
  }
}

          // let section = 'General Admission';
          // if (seatsData.length > 0) {
          //   if (seatsData.length === 1) {
          //     // Single seat
          //     const seat = seatsData[0];
          //     const sectionDisplay = seat.section === seat.rowNumber ? seat.section : `${seat.section} Row ${seat.rowNumber}`;
          //     const ticketType = seat.ticketType ? seat.ticketType.charAt(0).toUpperCase() + seat.ticketType.slice(1) : 'Adult';
          //     section = `${sectionDisplay} - Seat ${seat.seatNumber} (${ticketType})`;
          //   } else {
          //     // Multiple seats - group by section, row, and ticket type
          //     const seatGroups = {};
          //     seatsData.forEach(seat => {
          //       const sectionDisplay = seat.section === seat.rowNumber ? seat.section : `${seat.section} Row ${seat.rowNumber}`;
          //       const ticketType = seat.ticketType ? seat.ticketType.charAt(0).toUpperCase() + seat.ticketType.slice(1) : 'Adult';
          //       const key = `${sectionDisplay}_${ticketType}`;
          //       if (!seatGroups[key]) {
          //         seatGroups[key] = {
          //           sectionRow: sectionDisplay,
          //           ticketType: ticketType,
          //           seatNumbers: []
          //         };
          //       }
          //       seatGroups[key].seatNumbers.push(seat.seatNumber);
          //     });
              
          //     // Create section string with all groups
          //     const sectionParts = Object.values(seatGroups).map(group => {
          //       const seatNumbersStr = group.seatNumbers.join(', ');
          //       return `${group.sectionRow} - Seats ${seatNumbersStr} (${group.ticketType})`;
          //     });
              
          //     section = sectionParts.join('; ');
          //   }
          // }
          const tickets = seatsData.length;
          
          // Get event-specific images based on event title
          const eventImages = getEventImages(booking.event.title);

          return {
            id: booking._id,
            title: booking.event.title,
            date: new Date(booking.event.date).toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }),
            time: booking.event.time,
            location: `${booking.event.venue}, ${booking.event.city}`,
            tickets: tickets,
            section: section,
            image: booking.event.bannerImages?.[0] || booking.event.listImages?.[0] || eventImages.banner,
            ticketImage: eventImages.ticket, // Store ticket image for modal
            subTotal: (booking.totalPrice).toFixed(2),
            // bookingFee: 2,
            total: (booking.totalPrice).toFixed(2),
            bookingDate: new Date(booking.bookingDate).toLocaleString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            }),
            paymentMethod: 'CARD', // This might need to come from the API
            bookingId: booking._id.slice(-6).toUpperCase(),
            digitalTicket: seatsData.length > 0 ? seatsData[0].digitalTicket : null,
            seats: seatsData, // Store the seats data for QR slider
            // Additional fields for the modal
            taxes: {
              basePrice: ((booking.totalPrice - booking.platformFeeAmount)).toFixed(2),
              tax: (booking.platformFeeAmount).toFixed(2)
            }
          };
        });
        setBookings(transformedBookings || []);
        
        // Set total pages from response
        if (response.totalPages) {
          setTotalPages(response.totalPages);
        }
        
        setError(null);
      } catch (err) {
        // Check if it's an auth error
        if (err.message === 'Invalid Token' || err.message?.includes('401') || err.message?.includes('Unauthorized') || err.message?.includes('Access Denied')) {
          // Auth error - show login modal (handled by event listener)
          setError(null);
        } else {
          setError('Failed to fetch bookings. Please try again.');
        }
        console.error('Error fetching bookings:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBookings();

    return () => {
      window.removeEventListener('authError', handleAuthError);
    };
  }, [currentPage, limit]);

  const handleViewBooking = (booking) => {
    setSelectedBooking(booking);
    setCurrentQRIndex(0); // Reset to first QR code when opening modal
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleQRNavigation = (direction) => {
    if (!selectedBooking) return;
    
    const seatsData = selectedBooking.seats || [];
    const totalSeats = seatsData.length;
    
    if (direction === 'next') {
      setCurrentQRIndex((prev) => (prev + 1) % totalSeats);
    } else if (direction === 'prev') {
      setCurrentQRIndex((prev) => (prev - 1 + totalSeats) % totalSeats);
    }
  };

  const downloadTicketAsPDF = async (booking = null) => {
    const bookingToUse = booking || selectedBooking;
    if (!bookingToUse || isGeneratingPDF) return;
    
    setIsGeneratingPDF(true);
    try {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const seatsData = bookingToUse.seats || [];
      
      // Generate filename for the booking
      const filename = `tickets_${bookingToUse.title.replace(/\s+/g, '_')}_${bookingToUse.bookingId}.pdf`;
      
      // Process each seat/ticket
      for (let i = 0; i < seatsData.length; i++) {
        const currentSeat = seatsData[i];
        
        // Create a temporary ticket element for this seat
        const tempTicketElement = document.createElement('div');
        tempTicketElement.style.position = 'absolute';
        tempTicketElement.style.left = '-9999px';
        tempTicketElement.style.top = '-9999px';
        tempTicketElement.style.width = '700px'; // Reduced from 800px for smaller file size
        tempTicketElement.style.background = '#ffffff';
        tempTicketElement.style.padding = '15px'; // Reduced padding
        tempTicketElement.style.borderRadius = '10px';
        tempTicketElement.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
        
        // Create the ticket HTML content with QR code
        const ticketImageUrl = bookingToUse.ticketImage || defaultEventImage;
        tempTicketElement.innerHTML = `
          <div style="background: white; overflow: hidden;">
            <!-- Ticket Image at Top -->
            <img src="${ticketImageUrl}" alt="Event Ticket" style="width: 100%; height: auto; display: block; max-height: 300px; object-fit: cover; margin-bottom: 30px;" />
            
            <!-- Ticket Details Section -->
            <div style="display: flex; background: white; overflow: hidden;">
              <!-- Left Section -->
              <div style="flex: 2; padding: 20px;">
                <h4 style="margin: 0 0 15px 0; color: #333;">${bookingToUse.title}</h4>
                <p style="margin: 5px 0; color: #666;">
                  <strong>Date:</strong> ${bookingToUse.date} • ${bookingToUse.time}
                </p>
                <p style="margin: 5px 0; color: #666;">
                  <strong>Venue:</strong> ${bookingToUse.location}
                </p>
   <p>   
<strong>Section:</strong> ${currentSeat.section} - Seat ${i + 1}${
  currentSeat.ticketType
    ? ` (${currentSeat.ticketType.charAt(0).toUpperCase() + currentSeat.ticketType.slice(1)})`
    : ''
}

</p>
                <p style="margin: 5px 0; color: #666;">
                  <strong>Booking ID:</strong> ${bookingToUse.bookingId}
                </p>
                <p style="margin: 5px 0; color: #666;">
                  <strong>Total:</strong> £${bookingToUse.total}
                </p>
              </div>
              
              <!-- Right Section with QR Code -->
              <div style="flex: 1; background: ${getSectionBackgroundColor(currentSeat.section)}; padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: white;">
                <h6 style="margin: 0 0 10px 0; text-align: center;">
                  ${currentSeat.section} - Row ${currentSeat.rowNumber}, Seat ${currentSeat.seatNumber}${currentSeat.ticketType ? ` (${currentSeat.ticketType.charAt(0).toUpperCase() + currentSeat.ticketType.slice(1)})` : ''}
                </h6>
                <div style="background: rgba(255, 255, 255, 0.9); padding: 10px; border-radius: 10px;">
                  <div id="qr-container-${i}" style="width: 120px; height: 120px;"></div>
                </div>
              </div>
            </div>
          </div>
        `;
        
        // Add to DOM temporarily
        document.body.appendChild(tempTicketElement);
        
        // Wait for the image to load
        const img = tempTicketElement.querySelector('img');
        if (img) {
          await new Promise((resolve, reject) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = reject;
            }
          });
        }
        
        // Generate QR code using existing QRCodeSVG component (reduced size for smaller file)
        const qrElement = createElement(QRCodeSVG, {
          value: `https://tixbook.com/booking/${currentSeat.qrCodeToken}`,
          size: 120, // Reduced from 150 to 120 for smaller file size
          bgColor: "#ffffff",
          fgColor: "#000000",
          level: "H",
          includeMargin: true
        });
        
        // Render QR code to string and insert into container
        const qrContainer = tempTicketElement.querySelector(`#qr-container-${i}`);
        if (qrContainer) {
          qrContainer.innerHTML = renderToString(qrElement);
        }
        
        // Create canvas from the temporary element with reduced scale for smaller file size
        const canvas = await html2canvas(tempTicketElement, {
          scale: 1.5, // Reduced from 2 to 1.5 for smaller file size (still good quality)
          useCORS: true,
          allowTaint: true,
          backgroundColor: '#ffffff',
          logging: false,
          windowWidth: 800,
          windowHeight: tempTicketElement.scrollHeight
        });
        
        // Remove temporary element
        document.body.removeChild(tempTicketElement);
        
        // Convert to JPEG with compression for smaller file size (PNG is uncompressed)
        const imgData = canvas.toDataURL('image/jpeg', 0.85); // 85% quality JPEG
        
        // Calculate dimensions to fit the ticket properly
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 295; // A4 height in mm
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        
        // Center the image on the page
        const x = 0;
        const y = (pageHeight - imgHeight) / 2;
        
        // Add page if not the first ticket
        if (i > 0) {
          pdf.addPage();
        }
        
        pdf.addImage(imgData, 'JPEG', x, y, imgWidth, imgHeight);
      }
      
      // Download the PDF
      pdf.save(filename);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to download tickets. Please try again.');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  // Function to get background color based on section
  const getSectionBackgroundColor = (sectionName) => {
    const section = sectionName?.toLowerCase() || '';
    
    if (section.includes('vvip') || section.includes('premium') || section.includes('vv') || section.includes('gold')) {
      return 'radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%), radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%)'; // Gold gradient
    } else if (section.includes('vip') || section.includes('VVV') || section.includes('vvv') || section.includes('silver')) {
      return 'linear-gradient(to bottom, #cccccc 0%, #474747 0%, #d9d9d9 52%, #3e3e3e 97%)'; // Silver gradient
    } else if (section.includes('reserved') || section.includes('diamond')) {
      return 'linear-gradient(135deg, #B9F2FF 0%, #00CED1 50%, #1E90FF 100%)'; // Diamond - Rich cyan to deep blue gradient
    } else if (section.includes('standard')) {
      return 'linear-gradient(135deg, #4ECDC4 0%, #44A08D 100%)'; // Standard - Modern teal gradient
    } else if (section.includes('general') || section.includes('balcony')) {
      return 'linear-gradient(135deg, #FFB347 0%, #FF8C42 50%, #FF6B35 100%)'; // Balcony - Warm orange to coral gradient
    } else {
      return 'linear-gradient(135deg, #E6E6FA 0%, #9370DB 100%)'; // Default purple gradient
    }
  };

  if (loading) {
    return (
      <div className="container-xxl px-md-5 py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-xxl px-md-5 py-5 text-center">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  if (bookings.length === 0) {
    return (
      <div className="container-xxl px-md-5 py-5 text-center">
        <h3>No bookings found</h3>
        <p>You haven't made any bookings yet.</p>
        <Link to="/events" className="btn btn-primary">
          Browse Events
        </Link>
      </div>
    );
  }

  return (
    <AuthCheck redirectTo="/">
      <>
        {/* Full-screen loader overlay for PDF generation */}
        {isGeneratingPDF && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 9999,
              flexDirection: 'column'
            }}
          >
            <div className="spinner-border text-light" role="status" style={{ width: '3rem', height: '3rem' }}>
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="text-light mt-3" style={{ fontSize: '1.1rem', color: '#000' }}>Generating PDF tickets...</p>
            <p className="text-light mt-2" style={{ fontSize: '0.9rem', opacity: 0.8, color: '#000' }}>Please wait, this may take a moment</p>
          </div>
        )}
        <section className="container-xxl px-md-5">
          <div className="row p-md-4 py-5 px-3">
            {/* Sidebar */}
            <div className="col-md-2 border-end d-none d-md-block">
              <div className="p-3">
                <Link to="/my-bookings" className="btn btn-link active w-100 mb-3  border-0">
                  <FontAwesomeIcon icon={faTicket} className="me-2" />
                  My Bookings
                </Link>
                <Link to="/profile" className="btn btn-link  w-100 border-0">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  Profile
                </Link>
              </div>
            </div>

            {/* Booking Cards */}
            <div className="col-md-10 p-md-4 px-md-5">
              {bookings.map((booking, idx) => (
        
                <div key={idx} className="row  d-flex flex-wrap bg-white rounded mb-5 position-relative overflow-hidden">
                  {/* Left Ticket Section */}
                  <div className="d-flex col-md-8 px-0">
                    <div className="col-md-3 col-4">
                      <img src={booking.image} alt="Event" className="img-fluid h-100" style={{ objectFit: 'cover' }} />
                    </div>
                    <div className="col-md-9 col-8 p-3 ticket-info">
                      <div className="ms-3">
                        <h5 className="pe-md-5 pb-2">{booking.title}</h5>
                        <p className="mb-1 fw-3">
                          <FontAwesomeIcon icon={faCalendar} className="me-2" />
                          {booking.date} • {booking.time}
                        </p>
                        <p className="mb-1 fw-3 pb-4">
                          <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                          {booking.location}
                        </p>
                        {/* <p className="mb-1 pt-4 icon-pink">
                          <FontAwesomeIcon icon={faUsers} className="me-2" />
                      {booking.seats?.[0]?.rowNumber}{' '} - {booking.tickets} Ticket{booking.tickets > 1 ? 's' : ''}
                        </p> */}
                        {booking.seats &&
  Object.entries(
    booking.seats.reduce((acc, seat) => {
      const row = seat.rowNumber || 'Unknown';
      acc[row] = (acc[row] || 0) + 1;
      return acc;
    }, {})
  ).map(([rowNumber, ticketCount], index) => (
    <p key={index} className="mb-1  icon-pink">
      <FontAwesomeIcon icon={faUsers} className="me-2" />
      {rowNumber} - {ticketCount} Ticket{ticketCount > 1 ? 's' : ''}
    </p>
  ))}

                          {/* <FontAwesomeIcon icon={faChair} className="me-2" /> */}
                          {/* {booking.section} */}
                          <p className="mb-0 icon-pink">
  <FontAwesomeIcon icon={faChair} className="me-2" />
  {(() => {
    // get seats for this booking (current section)
    const seats = booking.seats || []; 
  

const tableName = seats[0]?.tableName || '';
    const totalSeats = seats.length;
// const rawSeatType = selectedSeats[0]?.tableName || '';
// const seattype = selectedSeats[0]?.tableName || '';
    // count Adults and Children
    const counts = seats.reduce((acc, seat) => {
      const type = seat.ticketType || 'adult';
      console.log('BOOKING SEATS 👉', booking.seats);

      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {});

    // format text
    return (
      <>
     {tableName}   {totalSeats} Seat{totalSeats > 1 ? 's' : ''} –{" "}
        {Object.entries(counts)
          .map(
            ([type, count]) =>
              `${count} ${type.charAt(0).toUpperCase() + type.slice(1)}${count > 1 ? 's' : ''}`
          )
          .join(", ")}
      </>
    );
  })()}
</p>


                        <button
                          onClick={() => {
                            setSelectedBooking(booking);
                            downloadTicketAsPDF(booking);
                          }}
                          className="btn btn-primary btn-sm me-2 mt-3"
                          title="Download All Tickets as PDF"
                          disabled={isGeneratingPDF}
                        >
                          {isGeneratingPDF ? (
                            <>
                              <FontAwesomeIcon icon={faSpinner} className="me-1 fa-spin" />
                              Generating PDF...
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faDownload} className="me-1" />
                              Download Tickets
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Right Pricing Section */}
                  <div className="col-md-4 p-md-4 text-start ticket-rhs position-relative">
                    <p className="mb-1">Sub Total <span className="float-end">£ {booking.subTotal}</span></p>
                    {/* <p className="mb-1">Booking Fee <span className="float-end">£ {booking.bookingFee}</span></p> */}
                    <hr className="my-2" />
                    <h6 className="">Order Total <span className="float-end">£ {booking.subTotal}</span></h6>
                    <div className="mx-auto text-center  mt-5">
                      <button className="btn btn-secondary"  data-bs-toggle="modal"
                        data-bs-target="#bookingModal"
                        onClick={() => handleViewBooking(booking)}>
                        <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
                        View Booking Info
                      </button>
                     
                    </div>
                  </div>
                </div>
              ))}

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <nav aria-label="Bookings pagination">
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>
                      
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </button>
                        </li>
                      ))}
                      
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Bootstrap Modal */}
        <div className="modal fade" id="bookingModal" tabIndex="-1" aria-labelledby="bookingModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body p-0">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                {/* <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                  <div>
                   
                    
                  </div>
                </div> */}
                {selectedBooking && (
                  <>
                    <div ref={ticketRef} className="row  d-flex flex-wrap bg-white rounded position-relative overflow-hidden modal-ticket">
                      {/* Left Ticket Section */}
                      <div className="d-flex col-md-8 px-0">
                       
                        <img src={selectedBooking.ticketImage || defaultEventImage} alt="Event" className="img-fluid h-100"/>
                      </div>

                      {/* Right Pricing Section */}
                      <div 
                        className="col-md-4 p-md-3 text-start ticket-rhs position-relative d-flex align-items-center justify-content-center"
                        style={{
                          background: getSectionBackgroundColor(selectedBooking.section),
                          color: '#fff',
                          textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                          position: 'relative'
                        }}
                      >
                        {/* Ticket Stub Effect - Bottom Right */}
                        {/* <div
                          style={{
                            content: "",
                            position: "absolute",
                            display: "block",
                            width: "2.5rem",
                            height: "2.5rem",
                            background: "#fff",
                            borderRadius: "50%",
                            right: "-1.3rem",
                            bottom: "-1.4rem",
                            border: "1px solid #ccc",
                            zIndex: 1
                          }}
                        /> */}
                        {/* Ticket Stub Effect - Top Right */}
                        {/* <div
                          style={{
                            content: "",
                            position: "absolute",
                            display: "block",
                            width: "2.5rem",
                            height: "2.5rem",
                            background: "#fff",
                            borderRadius: "50%",
                            right: "-1.3rem",
                            top: "-1.4rem",
                            border: "1px solid #ccc",
                            zIndex: 1
                          }}
                        /> */}
                        {/* <h5 className=" mb-3 pt-md-5">Price Details</h5>

                        <p className="mb-1">
                          Sub Total <span className="float-end">£ {selectedBooking.subTotal}</span>
                        </p>

                        <p className="mb-1">
                          Booking Fee <span className="float-end">£ {selectedBooking.bookingFee}</span>
                        </p>

                        <p
                          className="mb-1 small fw-3 cursor-pointer d-flex align-items-center"
                          onClick={() => setShowTaxes(!showTaxes)}
                          style={{ cursor: 'pointer' }}
                        >
                          Include Taxes
                          <span className="ms-1">
                            {showTaxes ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                width={'0.6rem'}
                              >
                                <path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                fill="currentColor"
                                width={'0.6rem'}
                              >
                                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                              </svg>
                            )}
                          </span>
                        </p>

                        {showTaxes && (
                          <>
                            <hr className="my-2 border-dashed" />

                            <p className="mb-1">
                              Base price <span className="float-end">£ {selectedBooking.taxes.basePrice}</span>
                            </p>

                            <p className="mb-1">
                              Tax <span className="float-end">£ {selectedBooking.taxes.tax}</span>
                            </p>
                          </>
                        )}

                        <h5 className=" mt-3 border-top pt-3">
                          Order Total <span className="float-end">£ {selectedBooking.total}</span>
                        </h5> */}

                        {/* QR Code Section */}
                        <div className="text-center mt-4">
                          {selectedBooking.seats && selectedBooking.seats.length > 0 && (
                            <>
                              {/* Seat Info Display */}
                              <div className="mb-3">
                                <h6 style={{ color: '#000', marginBottom: '10px' }}>
                                  {/* {selectedBooking.seats[currentQRIndex]?.section} -  {selectedBooking.seats[currentQRIndex]?.rowNumber}, Seat {selectedBooking.seats[currentQRIndex]?.seatNumber} */}
                                  {/* {selectedBooking.seats[currentQRIndex]?.section} -  {selectedBooking.seats[currentQRIndex]?.rowNumber},Seat {currentQRIndex + 1} */}
                               {selectedBooking.seats[currentQRIndex]?.section} -  Seat {currentQRIndex + 1}
                              
                                  {/* {selectedBooking.seats[currentQRIndex]?.ticketType && (
                                    <span> ({selectedBooking.seats[currentQRIndex].ticketType.charAt(0).toUpperCase() + selectedBooking.seats[currentQRIndex].ticketType.slice(1)})</span>
                                  )} */}
                                </h6>
                                {selectedBooking.seats.length > 1 && (
                                  <p style={{ color: '#000', fontSize: '14px' }}>
                                    {currentQRIndex + 1} of {selectedBooking.seats.length} tickets
                                  </p>
                                )}
                              </div>

                              {/* QR Code Container */}
                              <div 
                                style={{
                                  background: 'transparent',
                                  padding: '20px',
                                  borderRadius: '15px',
                                  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                                  position: 'relative',
                                  width: 'fit-content',
                                  margin: 'auto'
                                }}
                              >
                                                                <QRCodeSVG
                                  value={`https://tixbook.com/booking/${selectedBooking.seats[currentQRIndex]?.qrCodeToken || ''}`}
                                  size={120}
                                  bgColor="#ffffff"
                                  fgColor="#000000"
                                  level="H"
                                  includeMargin={true}
                                  key={`qr-${selectedBooking.seats[currentQRIndex]?.qrCodeToken}-${currentQRIndex}`}
                                />

                                {/* Navigation Arrows */}
                                {selectedBooking.seats.length > 1 && (
                                  <>
                                    <button
                                      onClick={() => handleQRNavigation('prev')}
                                      style={{
                                        position: 'absolute',
                                        left: '-3rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'rgba(0,0,0,0.6)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '40px',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faChevronLeft} />
                                    </button>
                                    <button
                                      onClick={() => handleQRNavigation('next')}
                                      style={{
                                        position: 'absolute',
                                        right: '-3rem',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'rgba(0,0,0,0.6)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '40px',
                                        color: 'white',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faChevronRight} />
                                    </button>
                                  </>
                                )}
                              </div>

                              {/* Dots Indicator */}
                              {selectedBooking.seats.length > 1 && (
                                <div className="mt-3 d-flex justify-content-center">
                                  {selectedBooking.seats.map((_, index) => (
                                    <button
                                      key={index}
                                      onClick={() => setCurrentQRIndex(index)}
                                      style={{
                                        width: '0.65rem',
                                        height: '0.65rem',
                                        borderRadius: '50%',
                                        border: 'none',
                                        background: index === currentQRIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                                        margin: '0 5px',
                                        cursor: 'pointer'
                                      }}
                                    />
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </AuthCheck>
  );
};

export default MyBookingsPage;

// pdf seat number
// //    <p style="margin: 5px 0; color: #666;">
//                    <strong>Section:</strong> ${currentSeat.section} - Seat ${currentSeat.seatNumber}${currentSeat.ticketType ? ` (${currentSeat.ticketType.charAt(0).toUpperCase() + currentSeat.ticketType.slice(1)})` : ''}
//                 </p>